angular.module('UndergroundWebApp').directive('executionStatusGauge', function () {
  return {
    restrict: 'E',
    scope: {
      executionStatus: '=',
      executionRate: '=',
      header: '=',
    },
    template: `
      <div class="execution-gauge-wrapper">
        <div class="chart-card-header">{{header}}</div>
        <div
          kendo-arc-gauge
          k-options="gaugeOptions"
          class="execution-gauge"
          ng-click="onGaugeClick($event)">
        </div>
        <div class="gauge-center-text" ng-class="animatedNumberSize">
          <span class="gauge-value" style="color: #5cb85c;">{{ executionStatus.green.amount }}</span>
          <span>/</span>
          <span class="gauge-value" style="color: #d9534f;">{{ executionStatus.red.amount }}</span>
        </div>
      </div>
    `,
    link: function (scope, element) {

      if(!scope.executionStatus || !scope.executionRate){
        return;
      }

      const green = scope.executionStatus.green.amount || 0;
      const red = scope.executionStatus.red.amount || 0;
      const length = green.toString().length + red.toString().length;

      if (length > 9) {
        scope.animatedNumberSize = 'small-size';
      } else if (length > 7) {
        scope.animatedNumberSize = 'medium-small-size';
      } else {
        scope.animatedNumberSize = 'normal-size';
      }

      scope.gaugeOptions = {
        value: scope.executionRate,
        color: '#5cb85c',
        centerTemplate: '',
        scale: {
          rangePlaceholderColor: '#d9534f',
          rangeLineCap: 'butt',
          rangeSize: 20
        },
        pointer: {
          visible: false
        }
      };
    }
  };
});
